import React, { ReactElement } from 'react';
import classNames from 'classnames';
import Carousel from 'react-multi-carousel';
import { useSelector } from '@ecommerce/nest-ssr/common';

import MainRanking from 'components/main/main-ranking/main-ranking';
import MainRankingsButtonGroup from 'components/main/rankings/button/button-group/main-rankings-button-group';
import { RankingGeneralByTypeInterface } from 'interfaces/ranking-general.interface';

import shops from 'assets/icons/shops.svg';
import certified from 'assets/icons/certified.svg';
import companies from 'assets/icons/companies.svg';
import products from 'assets/icons/products.svg';

import './main-rankings.desktop.scss';

interface MainRankingsProps {
    className: string;
}

const MainRankingsDesktop: React.FC<MainRankingsProps> = ({ className }): ReactElement => {
    const carouselClasses = classNames(className);

    const { companyRankings, productRankings } = useSelector(
        (state: { companyRankings: RankingGeneralByTypeInterface; productRankings: RankingGeneralByTypeInterface; }) => (
            { companyRankings: state.companyRankings, productRankings: state.productRankings }
        )
    );

    const responsiveData = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 3
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    return (
        <Carousel
            className={carouselClasses}
            responsive={responsiveData}
            showDots={false}
            arrows={false}
            infinite={true}
            ssr={true}
            customButtonGroup={<MainRankingsButtonGroup />}
            renderButtonGroupOutside={true}
            itemClass="main-ranking__slider-item"
        >
            <MainRanking
                key="1"
                icon={certified}
                model="company"
                bestRatingTypeBase="certifiedCompanyBestRating"
                bestRatingItems={companyRankings.certifiedCompanyBestRating30day}
                mostRatedTypeBase="certifiedCompanyMostRated"
                mostRatedItems={companyRankings.certifiedCompanyMostRated30day}
            >
                Z certyfikatem
                {''}
                <b>
                    Opineo
                </b>
            </MainRanking>
            <MainRanking
                key="2"
                icon={shops}
                model="company"
                bestRatingTypeBase="shopBestRating"
                bestRatingItems={companyRankings.shopBestRating30day}
                mostRatedTypeBase="shopMostRated"
                mostRatedItems={companyRankings.shopMostRated30day}
            >
                Sklepy
            </MainRanking>
            <MainRanking
                key="3"
                icon={companies}
                model="company"
                bestRatingTypeBase="firmBestRating"
                bestRatingItems={companyRankings.firmBestRating30day}
                mostRatedTypeBase="firmMostRated"
                mostRatedItems={companyRankings.firmMostRated30day}
            >
                Firmy
            </MainRanking>
            <MainRanking
                key="4"
                icon={products}
                model="product"
                bestRatingTypeBase="productBestRating"
                bestRatingItems={productRankings.productBestRating30day}
                mostRatedTypeBase="productMostRated"
                mostRatedItems={productRankings.productMostRated30day}
            >
                Produkty
            </MainRanking>
        </Carousel>
    );
};

export default MainRankingsDesktop;
